export default {
    created()
    {
        document.addEventListener('AppUpdated', this.updateAppMessage, { once: true })
        navigator.serviceWorker.addEventListener(
            'controllerchange', () => {
              if (this.refreshing) return;
              this.refreshing = true;
              window.location.reload();
            }
        );
    },
    methods: {
        data: () => ({
            registration:null,
            isRefresh: false,
            refreshing: false,
          }),        
        updateNow(){
            //Delete Cache
            caches.keys((key) => {
                caches.delete(key)
            })

            window.document.cookie = ''

            if (this.registration || this.registration.waiting) {
                 this.registration.waiting.postMessage({type:'SKIP_WAITING'});
            }
        },
        updateAppMessage(e){
            this.registration = e.detail;
            this.isRefresh = true;
            this.updateNow()
      
            // this.$vs.dialog({
            //     color: 'primary',
            //     title: 'Chegou uma nova atualização :)',
            //     text: "Uma nova atualização esta disponível",
            //     accept: () => { this.updateNow() },
            //     acceptText: 'Atualzar',
            //     buttonAccept: 'flat',
            // })
        }
    }
}